import { equals, map } from 'ramda';
import React from 'react';
import { availableChartTypes, ChartType } from '../../entities';
import Type from './Type';

interface Props {
  changeType: (type: ChartType) => void;
  type: ChartType;
}

const Types = ({ changeType, type }: Props) => {
  const renderType = (chartType: ChartType) => {
    const isActive = equals(chartType, type);

    return <Type changeType={changeType} isActive={isActive} key={chartType} type={chartType} />;
  };

  return <div>{map(renderType, availableChartTypes)}</div>;
};

export default Types;
